module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921032649_T.6e8cdb3d.jpg";